import { getNumberRoutes } from '../../../../src/app/get-number/get-number.routes';
import { firstStepsRoutes } from '../../../../src/app/first-steps/first-steps.routes';
var NUMBER_REQUIRED = { type: 'NUMBER_REQUIRED', redirectTo: '/first-steps', redirectToState: 'blocked.first-steps' };
var NumbersStateService = /** @class */ (function () {
    function NumbersStateService(MsisdnsService, $q, ipUserInfo, AmplitudeService, AccountService) {
        this.msisdnsService = MsisdnsService;
        this.$q = $q;
        this.ipUserInfo = ipUserInfo;
        this.amplitude = AmplitudeService;
        this.accountService = AccountService;
    }
    NumbersStateService.prototype.fetchNumbersAndBlockingStatus = function () {
        var _this = this;
        this.fetchAccountConfig();
        return this.$q(function (resolve, reject) { return _this.msisdnsService.query(function (res) {
            _this.numbers = res;
            _this.isFullyConfigured.promise.then(function (isFullyConfigured) {
                if (isFullyConfigured || _this.pathDoesNotRequireFullConfiguration()) {
                    resolve();
                }
                else {
                    reject(_this.rejectReason());
                }
            });
        }, function () { return reject(_this.rejectReason()); }); });
    };
    NumbersStateService.prototype.pathDoesNotRequireFullConfiguration = function () {
        var currentUrl = window.location.href;
        return notFullyConfiguredAwarePaths.some(function (path) { return currentUrl.includes(path); });
    };
    NumbersStateService.prototype.hasNumbers = function () {
        return this.numbers && this.numbers.length > 0;
    };
    NumbersStateService.prototype.fetchAccountConfig = function () {
        var _this = this;
        this.isFullyConfigured = this.$q.defer();
        this.accountService.getAccountConfig().subscribe(function (conf) {
            _this.isFullyConfigured.resolve(conf.data);
        });
    };
    NumbersStateService.prototype.rejectReason = function () {
        return Object.assign(NUMBER_REQUIRED);
    };
    NumbersStateService.$inject = ['MsisdnsService', '$q', 'ipUserInfo', 'AmplitudeService', 'AccountService'];
    return NumbersStateService;
}());
export default NumbersStateService;
var ɵ0 = function (_a) {
    var path = _a.path;
    return path;
}, ɵ1 = function (_a) {
    var path = _a.path;
    return path;
};
var notFullyConfiguredAwarePaths = getNumberRoutes.map(ɵ0).concat(firstStepsRoutes.map(ɵ1));
export { ɵ0, ɵ1 };
